module.exports = __webpack_public_path__ + "img/ez-slot-category-sport-hover.47a715cc.png";